<script>
  import { onDestroy } from 'svelte';
  import { getGroupStore } from '@stores/group';
  let sectionsStore = getGroupStore('sectionsStore');
  let recsStore = getGroupStore('recsStore');
  import ComponentEvents from '@utils/component-events';

  export let mobile = true;

  let sections = sectionsStore;
  let recs = recsStore;
  let maxShown = 3;

  let unsubSections = sectionsStore.subscribe((x) => (sections = x));
  let unsubRecs = recsStore.subscribe((x) => (recs = x));

  let showMore = function () {
    maxShown = 99;
  };

  let goToSection = async function (section) {
    ComponentEvents.trigger('mobile-scroll-to-section', section);
    ComponentEvents.trigger('mobile-set-current-section', { section });
  };

  onDestroy(() => {
    unsubSections();
    unsubRecs();
  });
</script>

<style style="text/scss" lang="scss">
  .mobile-sections {
    margin-top: 40px;

    .mobile-section {
      cursor: pointer;
      margin-top: 10px;
      background: #ffffff;
      box-shadow: 0px 4px 14px rgba(0, 0, 0, 0.08);
      border-radius: 15px;
      padding-top: 14px;
      padding-bottom: 14px;
      padding-left: 20px;
      padding-right: 20px;
      font-weight: 500;
      font-size: 14px;
      display: flex;
      align-items: center;
    }

    .show-more {
      cursor: pointer;
      margin-top: 15px;
      background: #f9f7fc;
      border-radius: 15px;
      padding-top: 14px;
      padding-bottom: 14px;
      padding-left: 20px;
      padding-right: 20px;
      color: #896bd9;
      display: flex;
      font-weight: 500;
      font-size: 14px;
      align-items: center;
    }

    .sections-title {
      font-size: 13px;
      font-weight: 500;
    }

    .sections-count {
      font-size: 13px;
      opacity: 0.5;
      margin-left: 6px;
    }

    .sections-title-and-count {
      margin-bottom: 16px;
    }

    &.desktop {
      margin-top: 14px;

      .sections-title {
        font-size: 14px;
        font-weight: 500;
        line-height: 26px;
      }

      .sections-count {
        font-size: 14px;
        line-height: 18px;
        opacity: 0.5;
        margin-left: 8px;
      }

      .sections-title-and-count {
        margin-bottom: 24px;
      }
    }
  }
</style>

{#if sections && sections.length > 0}
  <div class="mobile-sections" class:desktop={!mobile}>
    <div class="sections-title-and-count">
      <span class="sections-title">Sections</span>
      <span class="sections-count">
        {sections.length}
      </span>
    </div>
    {#each sections.sortBy((x) => x.position) as section, i}
      {#if i < maxShown}
        <div class="mobile-section" on:click={() => goToSection(section)}>
          <span style="flex: 1; word-break: break-word;">{section.name}</span>
          <span style="flex-shrink: 0; display: flex; margin-left: 14px;">
            <img alt="section" src="/emojis/purple_star.png" style="width: 15px; height: 15px;" />
            <span style="margin-left: 8px; font-size: 12px; opacity: 0.5;">
              {[...new Set(recs.where({ section_id: section.id }).map((x) => x.rec_object_id))].length}
            </span>
          </span>
        </div>
      {/if}
    {/each}

    {#if sections.length - maxShown > 0}
      <div class="show-more" on:click={showMore}>
        <span style="flex: 1">+ {sections.length - maxShown} more</span>
        <span style="flex-shrink: 0; display: flex;">
          <img src="/images/mobile/show-more-arrow.svg" />
        </span>
      </div>
    {/if}
  </div>
{/if}
